// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22H2V9H22V22ZM16.5 17L12.0001 12.5L7.5 17H16.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2V7H2V2H22Z"}}]};

const ExpandUpFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'expand-up-filled',
    ref,
    icon: element,
  },
));

ExpandUpFilledIcon.displayName = 'ExpandUpFilledIcon';

export default ExpandUpFilledIcon;
